module.exports = __webpack_public_path__ + "static/media/shippigo-by-emiza-white.52210c60.svg";